import { actors } from "@/mocks/actors";
import type { Work } from "@/types/work";

interface CastSectionProps {
  work: Work;
  onSearchActor: (name: string) => void;
}

export default function CastSection({ work, onSearchActor }: CastSectionProps) {
  const castList = work.cast
    .map((name) => actors.find((actor) => actor.name === name))
    .filter((actor): actor is (typeof actors)[number] => Boolean(actor));

  return (
    <section>
      <h2 className="flex items-center gap-2 font-heading text-xl font-extrabold text-foreground-950 md:text-2xl">
        <span className="h-5 w-1.5 rounded-full bg-accent-500" />
        演员介绍
      </h2>
      <div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-2">
        {castList.map((actor) => (
          <button
            key={actor.id}
            type="button"
            onClick={() => onSearchActor(actor.name)}
            className="flex gap-4 rounded-lg border border-background-200 bg-background-50 p-4 text-left transition-colors hover:border-primary-300"
          >
            <div className="h-20 w-20 shrink-0 overflow-hidden rounded-full bg-background-200">
              <img
                src={actor.avatar}
                alt={`${actor.name}头像`}
                title={`${actor.name} 演员资料`}
                className="h-full w-full object-cover object-top"
              />
            </div>
            <div className="min-w-0">
              <div className="flex items-center gap-2">
                <h3 className="font-heading text-base font-bold text-foreground-950 transition-colors hover:text-primary-700">
                  {actor.name}
                </h3>
                <span className="rounded bg-primary-50 px-1.5 py-0.5 text-[10px] font-medium text-primary-700">
                  {work.cast.includes(actor.name) ? "本片主演" : "演员"}
                </span>
              </div>
              <p className="mt-1.5 line-clamp-3 text-xs leading-relaxed text-foreground-600">
                {actor.bio}
              </p>
              <p className="mt-2 line-clamp-1 text-[11px] text-foreground-500">
                代表作：{actor.representative.join(" / ")}
              </p>
            </div>
          </button>
        ))}
      </div>
    </section>
  );
}